mutation updateTitleMutation($contentId: ID!, $title: String) {
  updateTitle(contentId: $contentId, title: $title) {
    id
    title
  }
}
